import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, BehaviorSubject, fromEvent, empty } from 'rxjs';
import { tap, debounceTime, switchMap, retry, catchError } from 'rxjs/operators';

import { FavoriteService } from '../../../services/favorite.service';

import { Multitenant } from '../../../services/multitenant.provider';
import { AuthProvider } from '../../../services/auth.provider';
import { GaEventTrackerProvider } from '../../../services/gaeventtracker.provider';
import { ConfigService } from '../../../services/config.service';


@Component({
  selector: 'app-favorite-button',
  templateUrl: './favorite-button.component.html',
})
export class FavoriteButtonComponent implements OnInit, OnDestroy, OnChanges {
  @Input() type: string;
  @Input() id: number;
  @Input() favorited = false;

  api$: Subscription;
  favorite$: BehaviorSubject<boolean>;

  constructor(
    public multiTenant: Multitenant,
    public authService: AuthProvider,
    public config: ConfigService,
    private router: Router,
    private favoriteService: FavoriteService,
    private element: ElementRef,
    @Optional() private gaService: GaEventTrackerProvider
  ) { }

  ngOnInit() {
    this.favorite$ = new BehaviorSubject(this.favorited);

    this.api$ = fromEvent(this.element.nativeElement, 'click')
      .pipe(
        tap(() => this.favorite$.next(!this.favorite$.getValue())),
        debounceTime(250),
        switchMap(() =>
          this.favoriteService
            .updateFavorite(this.type, this.id, this.favorite$.getValue())
            .pipe(
              tap(() => {
                if (this.gaService) {
                  this.gaService.trackEvent(
                    this.multiTenant.getDomainClass(),
                    'Clic',
                    this.favorite$.getValue()
                      ? 'Ajout​ ​aux​ ​favoris​ ​d’un article'
                      : 'Supprimer des Favoris',
                    null
                  );
                }
              }),
              retry(2),
              catchError(() => empty())
            )
        )
      )
      .subscribe();
  }

  ngOnChanges() {
    if (this.favorite$) {
      this.favorite$.next(this.favorited);
    }
  }

  ngOnDestroy() {
    this.api$.unsubscribe();
  }

  goToLogin() {
    if (this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.router.navigate(['connexion']);
    }

    if (this.multiTenant.getDomainClass() !== 'playbacpresse') {
      window.open('https://m-digital.playbacpresse.fr/connexion', '_blank');
    }
  }

}
